import "./App.css";
import Register from "./components/Register";
import Login from "./components/Login";
import ModalConfirmarItems from "./components/ModalConfirmarItems.jsx";
import Dashboard from "./components/Dashboard";
import LoginEnriched from "./components/LoginEnriched";
import AceptarTerminos from "./components/Terms&Conditions";
import WaitingTerms from "./components/WaitingTerms";
import LayOut from "./components/LayOut";
import FAQ from "./components/FAQ";
import LogOut from "./components/LogOut";
import Rifas from "./components/Rifas";
import Entregas from "./components/Entregas";
import Prendas from "./components/Prendas";
import TallesSection from "./components/TallesSection";
import DesignerPage from "./components/Designer/DesignerPage";
import InformPayment from "./components/MetodosDePago/InformPayment.jsx";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CargaCorrecta from "./components/CargaCorrecta.jsx";
import AccountsSummary from "./components/AccountsSummary.jsx";
import CargarTalles from "./components/CargarTalle.jsx";
import Modal1 from "./components/Modal1";
import ConfirmarTalle from "./components/ConfirmarTalles.jsx";
import AlertPropio from "./components/AlertPropio.jsx"
import TerminosCondiciones from "./components/TerminosCondicionesRifas.jsx";
import V3CustomerLogin from "./components/V3CustomerLogin.jsx";
import BackofficeLogin from "./components/BackofficeLogin.jsx";
import FormSizes from "./components/FormSizes/FormSizes.jsx";
import SwitchOrder from "./components/SwitchOrder.jsx";
import Payments from "./components/Payments.jsx";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/signin/enriched/:accessCode/code"
            element={<LoginEnriched />}
          />
          <Route
            path="/signin/automated/:accessCode/:password"
            element={<V3CustomerLogin />}
          />
          <Route
            path="/signin/backoffice/:token"
            element={<BackofficeLogin />}
          />
          <Route path="/terminos" element={<AceptarTerminos />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/esperando" element={<WaitingTerms />} />
          <Route path="/Modal1" element={<Modal1 />} />
          <Route path="/correcto" element={<CargaCorrecta />} />
          <Route path="/talles" element={<CargarTalles />} />
          <Route path="/verificar" element={<ConfirmarTalle />} />
          <Route path="/AlertPropio" element={<AlertPropio />} />
          <Route path="/ModalConfirmarItems" element={<ModalConfirmarItems />} />
          <Route path="/TerminosCondiciones" element={<TerminosCondiciones />} />
          <Route path="/switch" element={<SwitchOrder />} />



          <Route path="/mcb" element={<LayOut />}>
            <Route index element={<Dashboard />} />
            <Route path="pagos" element={<Payments />} />
            <Route path="accountsSummary" element={<AccountsSummary />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="logOut" element={<LogOut />} />
            <Route path="rifas" element={<Rifas />} />
            <Route path="entregas" element={<Entregas />} />
            <Route path="prendas" element={<Prendas />} />
            <Route path="talles" element={<TallesSection />} />
            {/* Go-live: el diseñador queda apagado por default (REACT_APP_DESIGNER_ENABLED). */}
            <Route
              path="prendas/designer/:orderItemId"
              element={
                String(process.env.REACT_APP_DESIGNER_ENABLED || "").toLowerCase() === "true"
                  ? <DesignerPage />
                  : <Prendas />
              }
            />
            <Route path="informar" element={<InformPayment />} />
            <Route path="correcto" element={<CargaCorrecta />} />
          </Route>

          <Route path="/form-sizes/:order_id/:is_tutor" element={<FormSizes />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
